import { render, staticRenderFns } from "./KullanimSuresiUyari.vue?vue&type=template&id=0c978834&scoped=true"
import script from "./KullanimSuresiUyari.vue?vue&type=script&lang=ts"
export * from "./KullanimSuresiUyari.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c978834",
  null
  
)

export default component.exports